/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mealy_Honest_Wombat_HugInputs */

const fr_mealy_honest_wombat_hug = /** @type {(inputs: Mealy_Honest_Wombat_HugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

/**

* @param {Mealy_Honest_Wombat_HugInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mealy_honest_wombat_hug = /** @type {((inputs?: Mealy_Honest_Wombat_HugInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mealy_Honest_Wombat_HugInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mealy_honest_wombat_hug(inputs)
});